import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { MemberService } from '../services/member.service';

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const memberService = inject(MemberService);
  const router = inject(Router);

  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  // SuperAdmin and TenantAdmin bypass all permission checks
  if (authService.isSuperAdmin() || authService.isTenantAdmin()) return true;

  // Get required permissions from route data
  const requiredPermissions = route.data['permissions'] as number | number[];

  if (!requiredPermissions) {
    // No permissions required, allow access
    return true;
  }

  // Check if user has required permissions
  const permissions = Array.isArray(requiredPermissions)
    ? requiredPermissions
    : [requiredPermissions];

  const hasPermission = authService.hasPermission(permissions, 'any');

  if (hasPermission) return true;

  // allowSelf: a route like /members/:id can still be opened, read-only, by a user
  // with no Member permissions if the :id in the URL is their own linked member id.
  if (route.data['allowSelf']) {
    const requestedId = route.paramMap.get('id');
    if (requestedId) {
      return memberService.getMyMemberId().pipe(
        map((myId) => {
          if (myId != null && myId === requestedId) return true;
          router.navigate(['/home']);
          return false;
        })
      );
    }
  }

  router.navigate(['/home']);
  return false;
};

